export default "__VITE_ASSET__CJmQKzyG__"